var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("ApplyButton", {
                staticClass: "ml-auto",
                attrs: {
                  applicationId: _vm.applicationId,
                  isCancelled: _vm.isApplicationCancelled,
                  postingId: _vm.posting.id,
                  currentUserId: _vm.currentUserId,
                },
                model: {
                  value: _vm.applicationExists,
                  callback: function ($$v) {
                    _vm.applicationExists = $$v
                  },
                  expression: "applicationExists",
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col w-full" },
        [
          _c(
            "RouterLink",
            {
              staticClass: "flex items-center",
              attrs: {
                to: {
                  name: _vm.routes.JOBBOARD_POSTING,
                  params: { id: _vm.posting.id },
                },
              },
            },
            [
              _c("CircleWithInitials", {
                staticClass: "mr-2",
                attrs: { title: _vm.posting.job_title },
              }),
              _c("div", [
                _c(
                  "p",
                  {
                    staticClass:
                      "font-bold text-base hover:text-primary-500 mb-2",
                  },
                  [_vm._v(_vm._s(_vm.posting.job_title))]
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "flex w-full flex-wrap -mt-1" }, [
            _c(
              "div",
              { staticClass: "flex flex-col w-64 ml-10 xlLabelContainer" },
              [
                !_vm.isMarketplace
                  ? _c(
                      "CardBodyItem",
                      { attrs: { label: "Company" } },
                      [
                        _c(
                          "RouterLink",
                          {
                            staticClass: "overflow-hidden truncate",
                            attrs: {
                              to: {
                                name: _vm.routes.NETWORK_COMPANY,
                                params: { id: _vm.posting.company.id },
                              },
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "font-bold text-base hover:text-primary-500 truncate",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.posting.company.business_name) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("CardBodyItem", {
                  staticClass: "text-base",
                  attrs: { label: "Location", content: _vm.location },
                }),
                _c("CardBodyItem", {
                  staticClass: "text-base",
                  attrs: {
                    label: "Posted date",
                    content: _vm._f("moment")(
                      _vm.posting.created_at,
                      "D MMM, YYYY"
                    ),
                  },
                }),
                _c("CardBodyItem", {
                  attrs: {
                    label: "Type:",
                    content: _vm.posting.employment_type,
                  },
                }),
                _vm.jobDuration
                  ? _c("CardBodyItem", {
                      attrs: {
                        label: "Job duration",
                        content: _vm.jobDuration,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ml-10 flex flex-col flex-1 xlLabelContainer" },
              [
                _c(
                  "CardBodyItem",
                  { attrs: { label: "Skills" } },
                  [
                    _c("ChipsWithMore", {
                      attrs: { chipWithLinkDatas: _vm.skillss },
                    }),
                  ],
                  1
                ),
                _c(
                  "CardBodyItem",
                  { attrs: { label: "Industries" } },
                  [
                    _c("ChipsWithMore", {
                      attrs: { chipWithLinkDatas: _vm.industriess },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }